import { Component, OnDestroy } from "@angular/core";
import { DatePipe, NgClass, NgIf } from "@angular/common";
import { OpportunityService } from "../../../services/opportunity.service";
import {
  faCircleEllipsis,
  faCircleStar,
  faMessageLines,
  faPhone,
  faPhoneVolume
} from "@fortawesome/pro-light-svg-icons";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import {
  CdkCell,
  CdkCellDef,
  CdkColumnDef,
  CdkHeaderCell,
  CdkHeaderCellDef,
  CdkHeaderRow,
  CdkHeaderRowDef,
  CdkRow,
  CdkRowDef,
  CdkTable
} from "@angular/cdk/table";
import { AvailableReferralDatasource } from "../../../utility/available-referral-datasource";
import { faGear } from "@fortawesome/pro-solid-svg-icons";
import { AuthGuard } from "../../../auth/auth.guard";
import { UtilityService } from "../../../services/utility.service";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { StateManagementService } from "../../../services/state-management.service";

@Component({
  selector: "app-claim-it-referrals",
  standalone: true,
  imports: [
    DatePipe,
    NgClass,
    FaIconComponent,
    CdkHeaderCellDef,
    CdkHeaderCell,
    CdkCell,
    CdkHeaderRow,
    CdkRow,
    CdkHeaderRowDef,
    CdkRowDef,
    CdkTable,
    CdkCellDef,
    CdkColumnDef,
    NgIf
  ],
  templateUrl: "./available-referrals.component.html",
  styleUrl: "./available-referrals.component.scss"
})
export class AvailableReferralsComponent implements OnDestroy {
  protected readonly faPhoneVolume: IconDefinition = faPhoneVolume;
  protected readonly faCircleEllipsis: IconDefinition = faCircleEllipsis;
  protected readonly faCircleStar: IconDefinition = faCircleStar;
  protected readonly faMessageLines: IconDefinition = faMessageLines;
  protected readonly faPhone: IconDefinition = faPhone;
  protected readonly faGear: IconDefinition = faGear;
  protected readonly UtilityService: typeof UtilityService = UtilityService;
  protected columnsToDisplay: string[] = [
    "addDate",
    "phone",
    "category",
    "businessLines",
    "industry",
    "noOfEmployees",
    "yearsInBusiness",
    "estimatedPremium",
    "city",
    "notes"
  ];
  protected sortKey: string = "addDate";
  protected sortDirection: string = "desc";
  protected pageNumber: number = 0;
  protected pageSize: number = 25;
  protected totalEntries: number = 200;
  private apiRefreshTimerInterval: number = 3000;
  protected dataSource: AvailableReferralDatasource = new AvailableReferralDatasource(
    this.opportunityService,
    this.sortKey,
    this.sortDirection,
    this.pageNumber,
    this.pageSize,
    this.apiRefreshTimerInterval
  );
  protected isLoading: boolean = true;

  constructor(
    private opportunityService: OpportunityService,
    private stateManagementService: StateManagementService,
    protected authGuard: AuthGuard
  ) {
    this.stateManagementService.setPageTitle("Available Claim-It Referrals | Momentum Edge");
    this.stateManagementService.pageHeading.set("Available Claim-It Referrals");
  }

  ngOnDestroy(): void {
    this.stateManagementService.resetHeadingAndTitle();
    this.dataSource.disconnect();
  }

  finishedLoading(): void {
    setTimeout((): boolean => (this.isLoading = false));
  }

  onSortClick(sortKey: any): void {
    if (this.sortKey === sortKey) {
      if (this.sortDirection === "desc") {
        this.sortDirection = "asc";
      } else if (this.sortDirection === "asc") {
        this.sortDirection = "";
      } else {
        this.sortDirection = "desc";
      }
    } else {
      this.sortKey = sortKey;
      this.sortDirection = "desc";
    }
    this.updateData();
  }

  updatePage(nextPage: number): void {
    if (
      (this.pageNumber + nextPage) * this.pageSize < this.totalEntries &&
      (this.pageNumber + nextPage) * this.pageSize >= 0
    ) {
      this.pageNumber += nextPage;
      this.updateData();
    }
  }

  updateData(): void {
    this.dataSource.disconnect();
    this.dataSource = new AvailableReferralDatasource(
      this.opportunityService,
      this.sortKey,
      this.sortDirection,
      this.pageNumber,
      this.pageSize,
      this.apiRefreshTimerInterval
    );
  }
}
